import React from 'react'

import GridDefault from './gridDefault'
import ListDefault from './listDefault'
import GridVideo from './gridVideo'

const ProductList = ({
  items,
  currentSite,
  preferences,
  itemDecorator,
  muteVideo,
  location,
  isSqueezed
}) => {
  const viewType = preferences.searchResultsViewType
  const videoMuted = preferences.searchVideoMuted

  if (viewType === 'grid') {
    if (currentSite === 'videohive') {
      return (
        <GridVideo
          items={items}
          viewType={viewType}
          videoMuted={videoMuted}
          muteVideo={muteVideo}
          currentSite={currentSite}
          itemDecorator={itemDecorator}
        />
      )
    } else {
      return (
        <GridDefault
          items={items}
          viewType={viewType}
          currentSite={currentSite}
          itemDecorator={itemDecorator}
          isSqueezed={isSqueezed}
        />
      )
    }
  } else {
    return (
      <ListDefault
        items={items}
        viewType={viewType}
        currentSite={currentSite}
        itemDecorator={itemDecorator}
        videoMuted={videoMuted}
        muteVideo={muteVideo}
        isSqueezed={isSqueezed}
      />
    )
  }
}

export default ProductList
